function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "star_golden_svg__a"
}, React.createElement("path", {
  fill: "none",
  d: "M0 0h22.562v21.551H0z"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#star_golden_svg__a)"
}, React.createElement("path", {
  d: "M11.717.276l3.219 6.529 7.2 1.058a.5.5 0 01.276.851l-5.219 5.081 1.241 7.173a.493.493 0 01-.713.529l-6.437-3.38-6.437 3.38a.493.493 0 01-.713-.529l1.241-7.173L.156 8.714a.5.5 0 01.276-.851l7.2-1.058L10.851.276a.484.484 0 01.866 0z",
  fill: "#ffeb3b"
}));

var SvgStarGolden = function SvgStarGolden(props) {
  return React.createElement("svg", _extends({
    width: 22.562,
    height: 21.551
  }, props), _ref, _ref2);
};

export default SvgStarGolden;